<template>
    <TreeTable :value="nodes" :expandedKeys="expandedKeys" >
        <Column field="name" :header="title" :expander="true" bodyClass="col-10"></Column>
        <Column header="pilih" headerClass="col-2" bodyClass="col-1">
            <template #body="slotProps">
                <Checkbox   
                    v-if="!slotProps.node.children"
                    :value="slotProps.node.data.name" 
                    v-model="model"
                    />
            </template>
        </Column>
    </TreeTable>
</template>

<script>
import TreeTable from 'primevue/treetable';
import Column from 'primevue/column';
import Checkbox from 'primevue/checkbox';
import PermissionService from '../Services/PermissionService';


export default {
    components: {
        TreeTable,
        Column,
        Checkbox
    },
    props: {
        title : {
            type : String,
            default : 'Permission'
        },
        modelValue : {
            type : Array,
            default : () => []
        },
    },
    computed : {
        model : {
            get() {
                return this.modelValue;
            },
            set(value) {
                // console.log(value);
                this.$emit('update:modelValue', value);
            }
        }
    },
    permissionService : null,
    data() {
        return { 
            nodes : [],
            expandedKeys : {},
            selected_permission : [],
        } 
    },
    created () {
        this.permissionService = new PermissionService();
    },
    mounted () {
        this.permissionService.getData().then(response => {
            this.nodes = response.data;
            this.expandAll();
        });
        
    },
    methods : {
        expandAll() {
            for (let node of this.nodes) {
                this.expandNode(node);
            }

            this.expandedKeys = {...this.expandedKeys};
        },
        expandNode(node) {
            if (node.children && node.children.length) {
                this.expandedKeys[node.key] = true;

                for (let child of node.children) {
                    this.expandNode(child);
                }
            }
        }
    }
}
</script>

<style>

</style>